import dayjs from 'dayjs';

import { OpeningHours } from '../types/api';
import { DefaultOpeningHours } from '../types/async-config';

export const isClosedWithinOpeningHours = (
  intervals: DefaultOpeningHours,
  openingHours: OpeningHours
): boolean => {
  const now = dayjs();

  const day = now.day();
  const dayInterval = intervals[day];

  const todayOpeningHours = openingHours.filter(({ date }) =>
    dayjs(date).isSame(now, 'date')
  );

  return (
    !!dayInterval &&
    now.isAfter(dayInterval.open) &&
    now.isBefore(dayInterval.close) &&
    todayOpeningHours.every(({ intervals }) =>
      intervals.every(
        ({ open, close }) => now.isBefore(open) || now.isAfter(close)
      )
    )
  );
};

export const isWithinOpeningHours = (
  intervals: DefaultOpeningHours,
  openingHours: OpeningHours
): boolean => {
  const now = dayjs();
  const day = now.day();
  const dayInterval = intervals[day];

  if (!dayInterval) {
    return false;
  }

  if (openingHours.every((hours) => !hours.intervals.length)) {
    return (
      !!now.day() &&
      now.isAfter(dayInterval.open) &&
      now.isBefore(dayInterval.close)
    );
  }

  return openingHours.some((hours) => {
    return (
      now.isSame(hours.date, 'date') &&
      hours.intervals.some(({ open, close }) => {
        return now.isAfter(open) && now.isBefore(close);
      })
    );
  });
};
